/**
 * @file
 * Ajax theme overrides.
 */
((Drupal, $) => {

  /**
   * Add class to body.
   */
  Drupal.Ajax.prototype.setProgressIndicatorThrobber = function () {
    document.body.classList.add('is-ajax-loading');
  };

  /**
   * Save the original callback to avoid copy-pasting.
   */
  const originalSuccessCallback = Drupal.Ajax.prototype.success;

  /**
   * Extends default success callback to remove extra class.
   */
  Drupal.Ajax.prototype.success = function (response, status) {
    originalSuccessCallback.call(this, response, status);
    // Do nothing on empty element. This most likely is BigPipe manual call for
    // AJAX success without any AJAX being called.
    if (!this.element) {
      return;
    }

    let dialogExist = response.find(cmd => cmd['command'] === 'openDialog');

    if (!dialogExist) {
      document.body.classList.remove('is-ajax-loading');
    }
  }

  // @todo Use "window.addEventListener('dialog:aftercreate'" after D10.3
  $(window).on('dialog:aftercreate', () => {
    document.body.classList.remove('is-ajax-loading');
  });

  /**
   * Save the original callback to avoid copy-pasting.
   */
  const originalErrorCallback = Drupal.Ajax.prototype.error;

  /**
   * Extends default success callback to remove extra class.
   */
  Drupal.Ajax.prototype.error = function (xmlhttprequest, uri, customMessage) {
    originalErrorCallback.call(this, xmlhttprequest, uri, customMessage);
    // @see Drupal.Ajax.prototype.success for explanation.
    if (!this.element) {
      return;
    }

    document.body.classList.remove('is-ajax-loading');
  }

  // @todo Use "window.addEventListener('dialog:aftercreate'" after D10.3
  $(window).on('dialog:aftercreate', () => {
    document.body.classList.remove('is-ajax-loading');
  });

})(Drupal, jQuery);
